export default "__VITE_ASSET__BpD9EXsi__"